/**
 * Trigger a browser download for an in-memory Blob (e.g. a CSV export streamed from the
 * API). Creates a temporary object URL, clicks a synthetic anchor, then revokes the URL.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  // Stop the synthetic click from bubbling to window, where preact-iso's
  // LocationProvider intercepts <a href> clicks and tries to history.pushState
  // to the blob: URL — which throws a SecurityError and aborts the download.
  anchor.addEventListener('click', (event) => event.stopPropagation())
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
